(function ($, Drupal) {
  Drupal.behaviors.randomAdDisplay = {
    attach: function (context, settings) {
      const adsCount = settings.randomAd.ads_count;
      const termIds = settings.randomAd.term_ids;
      const nodeIds = settings.randomAd.node_ids; // Get the node IDs from Drupal settings
      const cookieName = "random-ad-sequence";
      const lastAdCookieName = "last-ad-id";
      let currentAdIndex = parseInt(getCookie("current-ad-index"), 10);
      let adSequence = getCookie(cookieName)
        ? JSON.parse(getCookie(cookieName))
        : [];

      const lastAdId = getCookie(lastAdCookieName);

      // Initialize the ad sequence if not set or if it has been exhausted
      if (
        !adSequence.length ||
        isNaN(currentAdIndex) ||
        currentAdIndex >= adsCount
      ) {
        adSequence = shuffle(Array.from(Array(adsCount).keys()));
        currentAdIndex = 0;
      }

      // Select an ad and ensure it's not the same as the last one
      let adToShowIndex = selectNextAd(
        adSequence,
        currentAdIndex,
        nodeIds,
        lastAdId
      );

      // Expose the randomized endpoint parameters globally
      window.randomAdParams = {
        term_ids: termIds,
        ad_index: adToShowIndex,
      };

      // Update the current index for the next ad
      currentAdIndex++;

      // Save the sequence and current index to cookies
      setCookie(cookieName, JSON.stringify(adSequence));
      setCookie("current-ad-index", currentAdIndex);

      // Load the selected ad content via AJAX
      loadAdContent(adToShowIndex, termIds, lastAdCookieName);

      // Function to select the next ad that doesn't repeat the last shown one
      function selectNextAd(sequence, index, nodeIds, lastId) {
        let adIndex = sequence[index];
        let selectedNodeId = nodeIds[adIndex];

        if (adsCount > 1 && selectedNodeId === lastId) {
          do {
            index++;
            if (index >= sequence.length) {
              sequence = shuffle(Array.from(Array(adsCount).keys()));
              index = 0;
            }
            adIndex = sequence[index];
            selectedNodeId = nodeIds[adIndex];
          } while (selectedNodeId === lastId);
        }

        return adIndex;
      }

      // Function to load the selected ad content via AJAX
      function loadAdContent(adIndex, termIds, lastAdCookieName) {
        $.ajax({
          url: Drupal.url("civic-hero-ads/ajax/random-ad"),
          type: "GET",
          data: {
            term_ids: termIds,
            ad_index: adIndex,
          },
          success: function (response) {
            $("#random-ad-container", context).html(response.data);
            const loadedAdId = extractNodeIdFromResponse(response.data);
            if (loadedAdId) {
              setCookie(lastAdCookieName, loadedAdId);
            } else {
              console.error("Failed to extract Node ID from the response.");
            }
          },
          error: function () {
            console.error("Error loading the random ad content");
          },
        });
      }

      // Function to shuffle an array
      function shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]]; // Swap elements
        }
        return array;
      }

      // Function to get a cookie by name
      function getCookie(name) {
        const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );
        return match ? match[2] : null;
      }

      // Function to set a cookie
      function setCookie(name, value) {
        document.cookie = `${name}=${value}; path=/`;
      }

      // Function to extract the node ID from the response data
      function extractNodeIdFromResponse(data) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;
        const nodeElement = tempDiv.querySelector("[data-node-id]");

        // Add node id to global params
        const nid = nodeElement.getAttribute("data-node-id");
        window.randomAdParams["nid"] = nid;
        return nodeElement ? nodeElement.getAttribute("data-node-id") : null;
      }
    },
  };
})(jQuery, Drupal);
